import delegate from "delegate-it";
import easydropdown from "easydropdown-a11y";
import ajax from "@/scripts/common/ajax";
import { scrollToIfNeeded } from "@/scripts/common/scroll-to";
import { generateQueryString } from "@/scripts/common/util";
import { updateQueryParams } from "@/scripts/common/util";
import "@/styles/components/dropdown.css";

const form = document.querySelector(".filter-form");

const setupDropdown = (el) => {
  if (el.tagName !== "SELECT") {
    return;
  }

  const opts = {
    behavior: {
      openOnFocus: true,
      maxVisibleItems: 10,
      liveUpdates: true,
      useNativeUiOnMobile: false,
    },
  };

  easydropdown(el, opts);
};

const handleSortChange = (e) => {
  e.target.closest("button").disabled = true;

  const dir = e.detail.dir !== "" ? e.detail.dir : false;
  const url = updateQueryParams([["sort", dir]]);

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleFilterChange = (e) => {
  e && e.preventDefault();

  const currentUrl = new URL(window.location.href);
  const currentParams = new URLSearchParams(currentUrl.search);
  const currentView = currentParams.get("view");

  const params = new FormData(form);
  const queryString = generateQueryString(params);
  const url = queryString.size ? `${form.action}?${queryString}` : form.action;

  window.history.replaceState({}, "", url);

  if (currentView) {
    const url = updateQueryParams([["view", currentView]]);

    window.history.replaceState({}, "", url);
  }

  updateResults();
};

const handleFilterClear = () => {
  const currentUrl = new URL(window.location.href);
  const currentParams = new URLSearchParams(currentUrl.search);
  const currentView = currentParams.get("view");

  form.reset();
  form.querySelectorAll('input[type="search"]').forEach((x) => (x.value = null));
  form.querySelectorAll("select").forEach((x) => (x.value = ""));

  window.history.replaceState({}, "", form.action);

  if (currentView) {
    const url = updateQueryParams([["view", currentView]]);

    window.history.replaceState({}, "", url);
  }

  updateResults();
};

const updateResults = async () => {
  const pageContent = document.querySelector("[data-page-content]");

  pageContent.classList.add("is-loading");

  const res = await ajax.get(window.location.href).json();

  pageContent.innerHTML = res.page;
  pageContent.classList.remove("is-loading");

  if (res.isFiltered) {
    scrollToIfNeeded(pageContent, 24);
  }
};

document.addEventListener("DOMContentLoaded", () => {
  if (form) {
    form.querySelectorAll("select:not([multiple])").forEach((el) => setupDropdown(el));

    delegate(".filter-form select", "change", handleFilterChange);
    delegate(".filter-form", "submit", handleFilterChange);
    delegate(".filter-form-clear", "click", handleFilterClear);
  }

  delegate("html", "sort:change", handleSortChange);
});
